import React from "react";
import CustomModalWrapper from "../../../CustomModal";
import VerifyOtp from "./index.js";
var StandAloneVerifyOtpModal = function (props) {
    return (React.createElement(CustomModalWrapper, { Component: VerifyOtp, props: props }));
};
export default StandAloneVerifyOtpModal;
